module.exports = __webpack_public_path__ + "img/bgc1.a753e781.png";